import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { feedHobe, getHobeData, getHobeHintText } from '../api/hobeApi';

const useHobe = ({ fetchHobeData = false, fetchHobeHintText = false }) => {
    const queryClient = useQueryClient();

    const { data: hobeData, isLoading: hobeDataIsLoading } = useQuery({
        queryKey: ['getHobeData'],
        queryFn: getHobeData,
        staleTime: 30 * 60 * 1000,
        enabled: fetchHobeData
    });

    const { data: hobeHintText, isLoading: hobeHintTextIsLoading } = useQuery({
        queryKey: ['getHobeHintText'],
        queryFn: getHobeHintText,
        staleTime: 30 * 60 * 1000,
        enabled: fetchHobeHintText
    });

    const { mutateAsync: feedHobeMutateAsync, isLoading: feedHobeIsLoading } = useMutation({
        mutationFn: async ({ foodId, foodPrice }) => {
            const feedHobeResp = await feedHobe({ foodId });
            return { ...feedHobeResp, eatenFoodPrice: foodPrice };
        },
        onSuccess: (resp) => {
            queryClient.setQueryData(['getHobeData'], (hobeData) => {
                return {
                    ...hobeData,
                    user_state: { ...hobeData.user_state, energy: resp?.data?.energy }
                };
            });

            queryClient.setQueryData(['getWalletBalance'], (balance) => {
                return {
                    balance: balance?.balance - resp?.eatenFoodPrice
                };
            });
        }
    });

    return {
        hobeData,
        hobeDataIsLoading,
        feedHobeMutateAsync,
        feedHobeIsLoading,
        hobeHintText,
        hobeHintTextIsLoading
    };
};

export default useHobe;
